import * as React from 'react';
import { Link } from 'react-router-dom';
import Page from '../components/Page';
import Loader from '../components/Loader';
import { ErrorFlash } from '../components/Flash';
import { classes } from '../components/Button';
import { ShippingMethod } from '../shipping-method';
import { ProfileContext, ProfileManager } from '../profile';
import { useRequest, getHeaders } from '../api/client';
import ShippingMethodList from '../components/ShippingMethodList';

const newShippingMethod: ShippingMethod = {
  available: true,
  available_in: [],
  available_in_county: [],
  available_worldwide: true,
  company_id: '',
  delivery_time_days: 0,
  delivery_time_note: '',
  id: null,
  is_archived: false,
  is_free: false,
  max_subtotal: 0,
  max_weight: 0,
  min_subtotal: 0,
  min_weight: 0,
  name: '',
  price_amount: 0,
  price_currency: '',
  tax_amount: 0,
  tax_code: '',
  url: '',
  zone: '',
  created_at: null,
  updated_at: null,
};

const shippingMethods = (context: ProfileManager) => {
  const [state, _] = useRequest(() => ({
    url: '/store/shipping-methods',
    method: 'GET',
    headers: getHeaders(context),
  }));

  return state;
};

export default function ShippingMethods() {
  const context = React.useContext(ProfileContext);
  const state = shippingMethods(context);

  if (state.loading) {
    return <Loader />;
  }

  return (
    <Page
      title="Shipping Options"
      subtitle="Specify shipping options Filtru customers can choose from"
    >
      {state.error && <ErrorFlash error={state.error} />}
      <div className="flex justify-center ml-auto mr-auto">
        <Link
          to={{
            pathname: '/shipping-methods/new',
            state: {
              method: {
                ...newShippingMethod,
                company_id: context.profile.company_id,
              },
            },
          }}
          className={`${classes} dib ml-auto mr-auto`}
        >
          Create new
        </Link>
      </div>
      <ShippingMethodList methods={state.data || []} />
    </Page>
  );
}
